import { Box, Paper, Tab, Tabs, Typography } from "@mui/material";
import React, { useState } from "react";
import SalesPipelineDashboard from "../../components/reports/components/SalesPipelineDashboard";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel({ children, value, index, ...other }: TabPanelProps) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`report-tabpanel-${index}`}
      aria-labelledby={`report-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default function Reports() {
  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Typography variant="h4" gutterBottom>
        Säljrapporter
      </Typography>

      <Paper sx={{ width: "100%", mb: 2 }}>
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label="Säljtratt" />
          <Tab label="Leverantörer" />
          <Tab label="Trender" />
        </Tabs>
      </Paper>

      <TabPanel value={selectedTab} index={0}>
        <SalesPipelineDashboard />
      </TabPanel>

      <TabPanel value={selectedTab} index={1}></TabPanel>

      <TabPanel value={selectedTab} index={2}></TabPanel>
    </Box>
  );
}
